<label class="switch"
       (click)="toggle($event)">
  <input type="checkbox"
         [(ngModel)]="isSwitched"
         [disabled]="disabled" />
  <span class="slider round"></span>
</label>
